<layout>
  <top-bar [isDisplaySearch]="false" [isDisplayLogout]="true">
    <sub-navigation tab="accounts">
      <sub-navigation-item path="/supervisor" icon="supervisor_account">
        {{ (isSupervisor() ? 'USER.ISSUP' : 'ACCOUNT.LISTOFSITE') | translate }}
      </sub-navigation-item>
    </sub-navigation>
  </top-bar>

  <left-panel [isExpanded]="true">
    <div style="display: flex; width: 100%; height: 100%">
      @if (!$isMobile() || ($isMobile() && !$selectedAccount())) {
        <container [isScrollable]="true" verticalHeight="fill" padding="none">
          @if (isSupervisor()) {
            <div class="header-sticky">
              <aside-header [title]="'ACCOUNT.LISTOFACCOUNTS' | translate" />
            </div>
          }
          <container verticalHeight="fill" padding="medium">
            @for (account of $accounts(); track account) {
              <card-item
                [class]="
                  $selectedAccount()?.uid === account.uid && $selectedAccount()?.instance === account.instance
                    ? 'selected'
                    : ''
                "
                (click)="selectAccount(account)"
                [icon]="account.supervisor ? 'supervisor_account' : 'person'">
                <div class="account-card">
                  <div style="overflow: hidden">
                    <p class="account-card_company" [matTooltip]="account.company" ubiShowIfTruncated>
                      {{ account.company }}
                    </p>
                    <p class="account-card_name">{{ account.firstname }} {{ account.lastname }}</p>
                  </div>
                  @if (isSupervisor()) {
                    <p class="account-card_server">{{ account.instance }}</p>
                  }
                </div>
              </card-item>
            }
          </container>
        </container>
      }
      @if (!$isMobile() || ($isMobile() && $selectedAccount())) {
        <container [isScrollable]="true" verticalHeight="fill" padding="none">
          <div class="header-sticky">
            @if (isSupervisor()) {
              @if ($isMobile()) {
                <aside-header (onBack)="clearAccount()" [title]="'ACCOUNT.LISTOFSITE' | translate" />
              } @else {
                <aside-header [title]="'ACCOUNT.LISTOFSITE' | translate" />
              }
            }
            @if ($selectedAccount()) {
              <container [isScrollable]="false" padding="medium">
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-label>
                    {{ 'ACCOUNT.SEARCH' | translate }} ({{ $selectedAccount()?.instance }})
                  </mat-label>
                  <input autofocus matInput [formControl]="search" type="search" />
                  @if (search?.value) {
                    <button matSuffix matIconButton aria-label="Clear" (click)="clearSearch()">
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                </mat-form-field>
              </container>
            }
          </div>
          <container verticalHeight="fill" padding="medium">
            @if ($companyListFiltered()?.length === 0) {
              <alert style="margin: 1rem 0" genre="muted">{{ 'COMMON.NORESULT' | translate }}</alert>
            }

            @for (company of $companyListFinal(); track company.uid) {
              <card-item (click)="validateCompany(company)" icon="business">
                <p class="card_company">{{ company.full_name }}</p>
              </card-item>
            }
            @if (!$selectedAccount()) {
              <alert style="margin: 1rem 0" genre="muted">
                {{ (isSupervisor() ? 'CONNECTION.SELECT_SERVER' : 'CONNECTION.SELECT_ACCOUNT') | translate }}
              </alert>
            }
          </container>
        </container>
      }
    </div>
  </left-panel>
</layout>
